import { CommonModule } from '@angular/common'
import { booleanAttribute, Component, inject, Input } from '@angular/core'
import { MenuOpened } from '@monorepo-channels/shared/util-helpers'

@Component({
	standalone: true,
	selector: 'ui-pm-footer-buttons',
	imports: [CommonModule],
	template: `
		<div style="height: 46px; " *ngIf="type === 'fixed'"></div>
		<div
			[ngClass]="{
				'bottom-sheet-footer': true,
				fixed: type === 'fixed' || type === 'fixed-order',
				'fixed-order': type === 'fixed-order',
				'no-border': !border,
				'sidenav-open': menuOpened.sidenavOpened && type !== 'static'
			}"
		>
			<ng-content></ng-content>
		</div>
	`,
	styleUrl: './footer-buttons.component.scss',
})
export class FooterButtonsComponent {
	@Input() type: 'fixed' | 'fixed-order' | 'static' = 'static'
	@Input({ transform: booleanAttribute }) border: boolean = true
	public menuOpened = inject(MenuOpened)
}
